import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import Page from '../../@sprinx/react-web/Page';
import CataloguePageList from './components/CataloguePageList';
import CataloguePageListBreadcrumbs from './components/CataloguePageListBreadcrumbs';
import CataloguePageListHeadline from './components/CataloguePageListHeadline';

export type CataloguePageLayoutProps = StandardDivProps<CataloguePageLayoutClassKey>;

export type CataloguePageLayoutClassKey = 'root';

const themeSettings = { name: 'CataloguePageLayout' };
const useStyles = makeStyles(
  (/* theme */) =>
    createStyles<CataloguePageLayoutClassKey, {}>({
      root: {},
    }),
  themeSettings,
);

const CataloguePageLayout = React.forwardRef<HTMLDivElement, CataloguePageLayoutProps>(
  ({ className, classes: pClasses, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <Page
        ref={ref}
        className={clsx(classes.root, className)}
        pageTitle='Všechny produkty'
        breadcrumbs={<CataloguePageListBreadcrumbs />}
        {...rest}
      >
        <CataloguePageListHeadline />

        <CataloguePageList />
      </Page>
    );
  },
);

CataloguePageLayout.displayName = 'CataloguePageLayout';

export default withThemeProps(themeSettings)(CataloguePageLayout);
